import {
  GET_AUDIT_QUEUE_QUERY_KEY,
  useGetAuditTaskDataById,
  useGetAutomatedAuditStatus,
  useGetAutomatedAuditStatusV3,
  usePostAuditDiscrepancySession,
  usePostAuditDiscrepancyTaskResolution,
  usePostAuditTaskResolution,
  usePostEndQueueSession,
  usePostManualAuditTaskResolution,
  usePostStartQueueSession,
  useStartManualSession,
} from './useAudit'
import {
  useGenerateAutomatedAuditDiscrepancySession,
  useGenerateAutomatedAuditSession,
  useGenerateManualAuditSession,
} from './useGenerateSession'
import { useReviewDiscrepancy } from './useReview'
import {
  useVoidEngagementQualityMetrics,
  useVoidTaskQualityMetrics,
  VoidQualityMetricsRequest,
} from './useVoidQualityMetrics'

export const audit = {
  generateManualSession: useGenerateManualAuditSession,
  generateAutomatedSession: useGenerateAutomatedAuditSession,
  generateAutomatedDiscrepancySession: useGenerateAutomatedAuditDiscrepancySession,
  getAutomatedAudit: useGetAutomatedAuditStatus,
  reviewDiscrepancy: useReviewDiscrepancy,
  v3: {
    getAuditQueueState: useGetAutomatedAuditStatusV3,
    getAuditQueueStateQueryKey: GET_AUDIT_QUEUE_QUERY_KEY,
    startAuditQueueSession: usePostStartQueueSession,
    manuallyEndAuditQueueSession: usePostEndQueueSession,
    getAuditQueueSessionTaskById: useGetAuditTaskDataById,
    startAuditDiscrepancySession: usePostAuditDiscrepancySession,
    submitTaskResolution: usePostAuditTaskResolution,
    submitDiscrepancyTaskResolution: usePostAuditDiscrepancyTaskResolution,
    startManualSession: useStartManualSession,
    submitManualTaskResolution: usePostManualAuditTaskResolution,
    voidEngagementAudit: useVoidEngagementQualityMetrics,
    voidTaskAudit: useVoidTaskQualityMetrics,
  },
}

export type {
  ManualAuditTaskResolution,
  ManualSearchSummary,
  ManualSessionStartParams,
  ManualSessionStartRequest,
  ManualSessionStartResponse,
} from './useAudit'
export type { AuditVoidRequestAcceptedResponse } from './useVoidQualityMetrics'
export type { VoidQualityMetricsRequest }
